module.exports = __webpack_public_path__ + "static/img/label-01.9779e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/system/label-01.png
// module id = WRoU
// module chunks = 150